import * as React from 'react';
import { statusPill, statusDot, type StatusTone } from '../../../design-system/visual';
import { formatDateTime } from '../../../design-system/format';
import type { AgentStatus } from '../types';

const TONE: Record<AgentStatus, StatusTone> = {
  online: 'success',
  stale: 'warning',
  offline: 'destructive',
  never: 'muted',
};

const LABEL: Record<AgentStatus, string> = {
  online: 'Online',
  stale: 'Stale',
  offline: 'Offline',
  never: 'Never connected',
};

interface Props {
  status: AgentStatus;
  lastHeartbeatAt?: string | null;
  className?: string;
}

export function AgentStatusPill({ status, lastHeartbeatAt, className }: Props) {
  const tone = TONE[status];
  const title =
    status === 'never'
      ? 'This agent has never connected'
      : lastHeartbeatAt
        ? `Last seen ${formatDateTime(lastHeartbeatAt)}`
        : 'Last seen — unknown';

  return (
    <span className={[statusPill(tone), className].filter(Boolean).join(' ')} title={title}>
      <span className={statusDot(tone)} />
      {LABEL[status]}
    </span>
  );
}
